import { Component, OnInit } from "@angular/core";
import { GlobalLogoutService } from "../../../src/app/service/global-logout.service";
import { TranslateModule } from '@ngx-translate/core';

/**
* Component that triggers and handles global logout behavior when initialized.
* @component
* @selector app-global-logout
* @example
*   <app-global-logout></app-global-logout>
* @input none - This component does not accept any input properties.
* @output none - This component does not emit any output events.
* @method ngOnInit - Invokes the global logout service to process incoming logout actions when the component initializes.
* @lifecycle OnInit - Performs logout handling during component initialization.
*/
@Component({
  selector: 'app-global-logout',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './global-logout.component.html',
  styleUrl: './global-logout.component.css',
})
export class GlobalLogoutComponent implements OnInit {

  constructor(private globalLogoutService: GlobalLogoutService) {}

  ngOnInit(): void {
    this.globalLogoutService.handleIncomingLogout();
  }
}
